import {Module, Action, getModule} from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';
import {getList} from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import {CancellationReasons} from '@/models/cancellationReasons';
import {Filter} from "@/types/filter/filter";
import filterModel from "@/store/cancellationReasons/filterModel";
import CancellationReasonsFilter from "@/store/cancellationReasons/filterEntity";

export const MODULE_NAME = CancellationReasons.moduleName;

@Module({dynamic: true, store, name: MODULE_NAME, namespaced: true})
class CancellationReasonsModule extends PageBaseModule {
    filter: Filter;

    constructor(module: CancellationReasonsModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle(CancellationReasons.listTitle);
        page.setTitleAdd(CancellationReasons.createTitle);
        page.values.actionPagination = 'cancellationReasons/updatePage';
        page.values.actionPageAmountItems = 'cancellationReasons/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${CancellationReasons.moduleName}_edit`;
        this.pageSettings.routeParam = `${CancellationReasons.moduleName}Id`;

        const filter = new filterModel();
        this.filter = getModule(CancellationReasonsFilter);
        this.filter.setFilterName('cancellationReasonsFilter');
        this.filter.setTemplateClassName('template-lg directory-filters');
        this.filter.setFilterModel(filter.filterModel);
        this.filter.setFilterHandlers(filter.filterHandlers);
    }

    @Action({rawError: true})
    async init() {
        await this.getList();
    }

    @Action({rawError: true})
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(
                CancellationReasons.apiPrefix,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,
            );
            await this.context.dispatch('setList', result.table);
        } catch (clientError: any) {
            const error = clientError.response.data;

            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            await this.context.dispatch('updatePage', 1);
        }
    }
}

export default getModule(CancellationReasonsModule);
